function A2() {
    return (
        <main className='main'>
            <h2>Опис трудових функцій; професійні компетентності; знання, уміння та навички</h2>
            <table>
                <tr>
                    <td colSpan="3">
                        А2 Проектувальна
                    </td>
                </tr>
                <tr className='bold'>
                    <td>Професійні компетентності (за трудовою дією або групою трудових дій)</td>
                    <td>Знання</td>
                    <td>Уміння та навички</td>
                </tr>

                <tr>
                    <td rowSpan="3">
                        А2.1 Здатність до проектування та аналізу ефективності організації освітнього простору
                    </td>
                    <td>
                        А2.1.31 Принцип універсального дизайну та розумного пристосування
                    </td>
                    <td>
                        А2.1.У1 Аналізувати ефективність проектування та організації освітнього простору з урахуванням принципів універсального дизайну та розумного пристосування
                    </td>
                </tr>
                <tr>
                    <td>
                        А2.1.32 Санітарно-гігієнічні вимоги до улаштування території та приміщень закладу дошкільної освіти
                    </td>
                    <td>
                        А2.1.У2 Організовувати безпечний освітній простір з урахуванням санітарно-гігієнічних вимог
                    </td>
                </tr>
                <tr>
                    <td>
                        А2.1.33 Вимоги до розвивального та інклюзивного освітнього простору
                    </td>
                    <td>
                        А2.1.У3 Проектувати освітній простір закладу дошкільної освіти з урахуванням вікових особливостей, психічного розвитку та потреб здобувачів освіти
                    </td>
                </tr>
                <tr>
                    <td rowSpan="2">
                        А2.2 Здатність до створення безпечних і нешкідливих умов праці
                    </td>
                    <td>
                        А2.2.31 Санітарні, ергономічні вимоги до проектування робочих місць, охорони праці працівників закладу дошкільної освіти
                    </td>
                    <td>
                        А2.2.У1 Організовувати робочі місця працівників закладу дошкільної освіти з урахуванням санітарних, ергономічних вимог та вимог з охорони праці
                    </td>
                </tr>
                <tr>
                    <td>
                        А2.2.32 Порядок атестації робочих місць працівників закладу дошкільної освіти
                    </td>
                    <td>
                        А2.2.У2 Здійснювати своєчасну атестацію робочих місць
                    </td>
                </tr>
            </table>
        </main>
    )
}

export {A2}